import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import {
  IInfoPlanDevice,
  IClientInfo,
} from "../../provider/create.provider.interfaces";

interface IProps {
  children: ReactNode;
}

interface IAuthAgent {
  email: string;
  password: string;
}

type IContext = {
  step: number;
  user: IAuthAgent | null;
  client: IClientInfo | null;
  infoPlanDevice: IInfoPlanDevice | null;
  touchID: string | null;
  setStep: Dispatch<SetStateAction<number>>;
  setUser: Dispatch<SetStateAction<IAuthAgent | null>>;
  setInfoPlanDevice: Dispatch<SetStateAction<IInfoPlanDevice | null>>;
  setClient: Dispatch<SetStateAction<IClientInfo | null>>;
  setTouchID: Dispatch<SetStateAction<string | null>>;
  handleInitialState: () => void;
};

export const CreateUsedContext = React.createContext<IContext>({} as IContext);
export const useCreateUsedContext = () =>
  useContext<IContext>(CreateUsedContext);

const CreateUsedProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [user, setUser] = useState<IAuthAgent | null>(null);
  const [infoPlanDevice, setInfoPlanDevice] = useState<IInfoPlanDevice | null>(
    null,
  );
  const [touchID, setTouchID] = useState<string | null>(null);
  const [client, setClient] = useState<IClientInfo | null>(null);
  const handleInitialState = () => {
    setStep(1);
    setUser(null);
    setInfoPlanDevice(null);
    setClient(null);
  };
  const context: IContext = useMemo(
    () => ({
      step,
      user,
      infoPlanDevice,
      client,
      touchID,
      setStep,
      setUser,
      setInfoPlanDevice,
      setClient,
      setTouchID,
      handleInitialState,
    }),
    [step, user, infoPlanDevice, client, touchID],
  );
  return (
    <CreateUsedContext.Provider value={context}>
      {children}
    </CreateUsedContext.Provider>
  );
};

export default CreateUsedProvider;
